<template>
  <el-row>
    <el-col :span="12">
      <div class="content-item flex">
        <div class="content-item-label">来源标签</div>
        <div class="symptom-tab-list flex">
          <div class="top-wrap">
            <el-radio-group
              v-model="selectedOption"
              class="select"
              :disabled="isDisabled"
            >
              <el-radio label="无">无</el-radio>
              <el-radio label="品牌合作">品牌合作</el-radio>
              <el-radio label="算法生成视频" :disabled="true"
                >算法生成视频</el-radio
              >
            </el-radio-group>
            <div class="symptom-tips blue have" @click="sourceTips = true">
              为什么要打来源标签？
            </div>
          </div>
        </div>

        <el-dialog
          class="tips-dialog"
          title="为什么要打来源标签"
          :show-close="false"
          :visible.sync="sourceTips"
          width="722px"
          center
        >
          <div>
            <p class="before-content-color title">
              <span class="before-icon"></span> 来源标签说明
            </p>
            <p class="dialog-contents">
              来源标签仅用于特殊业务场景使用，如未线下与内容运营约定使用场景，则默认无需选择。
            </p>
            <p class="dialog-contents">
              当前支持场景：医药品类（非秒送）买后必看使用
            </p>
            <p class="dialog-contents">规则更新时间：2025.06.05</p>
          </div>
          <div slot="footer" class="dialog-footer btns">
            <el-button
              type="primary"
              @click="sourceTips = false"
              class="dialog-but"
              >我知道了</el-button
            >
          </div>
        </el-dialog>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { request } from "@/utils/axios";
import modal from "@/components/modal";
export default {
  name: "symptomLabel",
  props: ["functionIds", "largeModelLabelBizDTOS", "labelType", "data"],
  data() {
    return {
      sourceTips: false,
      selectedOption: "无",
      labels: [],
      newData: null,
    };
  },
  components: {
    modal,
  },
  watch: {
    selectedOption(newVal) {
      if (newVal !== "无") {
        const selectedLabel = this.labels.find(
          (label) => label.name === newVal
        );
        if (selectedLabel) {
          this.$emit("changeSourceLabels", selectedLabel);
          this.newData = selectedLabel;
        }
      } else {
        this.newData = null;
      }
    },
    data(val) {
      this.data = val;
      const foundLabel = this.labels.find((label) =>
        val.some((item) => item.id === label.id)
      );
      if (foundLabel) {
        this.selectedOption = foundLabel.name;
      }
    },
  },
  mounted() {
    this.queryLabels();
    this.initData();
  },
  computed: {
    isDisabled() {
      return this.selectedOption === "算法生成视频";
    },
  },
  methods: {
    queryLabels() {
      if (this.labelType) {
        this.labels = [
          {
            updateUser: "xubo75",
            updateTime: 1748423762000,
            pid: -1,
            labelLevel: 1,
            labelGroupId: 10024950,
            createTime: 1748423762000,
            tenantId: 287,
            name: "算法生成视频",
            createUser: "xubo75",
            id: 10186994,
            class: "com.jd.cmp.business.gateway.dto.ContentLabelBizDTO",
            invisibleStatus: 1,
            contentLabels: [],
          },
          {
            updateUser: "xubo75",
            updateTime: 1748423771000,
            pid: -1,
            labelLevel: 1,
            labelGroupId: 10024950,
            createTime: 1748423771000,
            tenantId: 287,
            name: "品牌合作",
            createUser: "xubo75",
            id: 10200926,
            class: "com.jd.cmp.business.gateway.dto.ContentLabelBizDTO",
            invisibleStatus: 1,
            contentLabels: [],
          },
        ];
      } else {
        this.labels = [
          {
            updateUser: "xubo75",
            updateTime: 1747835189000,
            pid: -1,
            labelLevel: 1,
            labelGroupId: 10031949,
            createTime: 1747835189000,
            tenantId: 290,
            name: "算法生成视频",
            createUser: "xubo75",
            id: 10186993,
            class: "com.jd.cmp.business.gateway.dto.ContentLabelBizDTO",
            invisibleStatus: 1,
            contentLabels: [],
          },
          {
            updateUser: "xubo75",
            updateTime: 1747835183000,
            pid: -1,
            labelLevel: 1,
            labelGroupId: 10031949,
            createTime: 1747835183000,
            tenantId: 290,
            name: "品牌合作",
            createUser: "xubo75",
            id: 10209922,
            class: "com.jd.cmp.business.gateway.dto.ContentLabelBizDTO",
            invisibleStatus: 1,
            contentLabels: [],
          },
        ];
      }
    },
    initData() {
      const foundLabel = this.labels.find((label) =>
        this.data.some((item) => item.id === label.id)
      );
      if (foundLabel) {
        this.selectedOption = foundLabel.name;
      } else {
        this.selectedOption = null;
      }
    },
    getFormLabelData(form) {
      if (this.newData) {
        form.extensionContentLabels.push(this.newData);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
$color: #266cee;

.input-with-select {
  width: 437px !important;
  padding-bottom: 4px !important;
}

//症状搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;

  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }

    .el-checkbox {
      margin-right: 24px;
    }

    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }

    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }

  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }

    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}

.have {
  cursor: pointer;
}

.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}

:deep(.content-item) {
  min-width: 100% !important;
}

.dialog-but {
  padding-top: 9px;
}

:deep(.button) {
  line-height: 0px !important;
}
:deep(.content-item) {
  min-width: 100% !important;
}
:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}

.search-but {
  padding-top: 8px;
}

.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}

.symptom-tips {
  width: 147px !important;
  height: 20px;
  // position: absolute;
  // left: 560px;
  // top: 0;
}

.symptom-tab-add {
  width: 105px !important;
  position: absolute !important;
  left: 0px;
  top: -43px;
}

.symptom-tab-list {
  // position: relative !important;
  flex-direction: column !important;

  .top-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .select {
      width: 400px;
      margin: 0;
      padding-top: 5px;
    }

    .symptom-tab {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: center;
      // background: rgba(255, 110, 0, 0.12);
      border-radius: 2px;
      padding: 0 16px;
      margin-right: 28px;
      cursor: pointer;
      position: relative;
      margin-bottom: 10px;

      img {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 15px;
        height: 15px;
        background-size: 15px;
      }
    }
  }

  .symptom-tab-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .symptom-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    // margin-top: 40px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;

    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }

  .symptom-tab-add {
    position: static !important;
    margin-top: 0px !important;
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);

    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }

    &::after {
      display: none;
    }
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;

    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }

    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>
